import { observer } from 'mobx-react-lite'
import React from 'react'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import styles from './styles.module.scss'
import { type CallQueueStore } from '../../store/CallQueueStore'

type IActionEditContentProps = {
  store: CallQueueStore
}
export const CallQueueActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingMessageStore, greetingMusicStore } = store

  return (
    <div className={styles.wrap}>
      <GreetingAudioBlockEditContent labelText={'Greeting message'} store={greetingMessageStore} />
      <GreetingAudioBlockEditContent labelText={'Greeting music'} store={greetingMusicStore} />
    </div>
  )
})
